module.exports = __webpack_public_path__ + "img/564e977.564e977b.png";